var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.556 3.567a.567.567 0 00-1.133 0v1.502a.567.567 0 101.133 0V3.567zm.422 7.328c1.934-.1 5.062-6.307 5.062-6.307v9.106H4.396s1.654-3.544 3.152-3.637c.708-.044 1.085.16 1.487.38.182.098.368.2.593.282a.559.559 0 01.361-.14.56.56 0 01.496.308c.164.012.329.015.493.008zm-.989-4.162c.313 0 .567.253.567.566v1.503a.567.567 0 01-1.133 0V7.299c0-.313.253-.566.566-.566zm-6.64-3.68a.565.565 0 01.784.523v10.586h12.832a.567.567 0 010 1.135h-6.409v1.136A.565.565 0 019.99 17a.565.565 0 01-.566-.567v-1.136H3.574l-.004-.002-.003.002A.565.565 0 013 14.73V3.577a.565.565 0 01.35-.524z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default ForwardRef;